import type { FaireProductEntity } from "../../entity_types/product";

export const p_mbdtz46e22: FaireProductEntity = {
  token: "p_mbdtz46e22",
  type: "product",
  name: "Jacquard Weave Slim-Fit Blazer",
  brandToken: "b_wrt3xtnbxw",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/4451da0edd2767ec15dd53869990d7a783e0752361d2dfef0546220c4796b3b9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/79b454fea5768f38e0510ec80c802f41a35c45eb29779bccdf19cce80b84da0a.jpeg",
    "https://cdn.faire.com/fastly/9c67eec5436cdc00544d3a1eb42f84cd7c2040f12381a1139a6647481ded78f6.jpeg",
    "https://cdn.faire.com/fastly/e794e7c784bb09b54a848167cc8d2a255103de63104f1f7decac4a0e9efd124a.jpeg",
    "https://cdn.faire.com/fastly/3a4e83a86ec9ef9d66fef1a4f4c3cc9dff455508c60eef9e26c00b46fb203c67.jpeg",
    "https://cdn.faire.com/fastly/dfa9582253fc3096624c9236cc560b3a7062812cdfb1007847fc51c258c0cf2d.jpeg",
    "https://cdn.faire.com/fastly/90ef2cb6e5aa042eba8713a752970e2115004b5e248df3be88559693dc30a5a9.jpeg",
    "https://cdn.faire.com/fastly/5ed07783fec919a080bcbce102c5e33776939bca4f3c2b293f44d4310902bfae.jpeg",
    "https://cdn.faire.com/fastly/776ff99d31d8a8f0558462236436fc0acc61fd83ffe4240f5c5bb7661b2a6b98.jpeg",
    "https://cdn.faire.com/fastly/50504cfd0ab9103a0b8900a74d33dc76d583abea190b389900f431a17c13588d.jpeg",
    "https://cdn.faire.com/fastly/569f38452441474ca11330b55a4713bd79e411e623ccc7c436eededfb4963b7c.jpeg",
    "https://cdn.faire.com/fastly/e7b3ca6fa9d4a446111aeb578f6ebc4291da13bd06f29ec58bf78c7007520366.jpeg",
  ],
  priceDollars: 42.5,
  description:
    "ELEVATE YOUR FORMAL ATTIRE WITH THIS SLEEK JACQUARD WEAVE BLAZER, FEATURING A TAILORED SLIM FIT AND TEXTURED FABRIC FOR A SHARP, CONTEMPORARY SILHOUETTE.\n\nIMPORTED, DESIGNED IN USA\n\nINTRICATE JACQUARD WEAVE AND TEXTURED FINISH\n\nTAILORED SLIM FIT AND STRUCTURED SHOULDERS\n\nCONT 100% POLYESTER\n\nModel is 5'9\" and is wearing a small. Please see size chart for detail.\n\nShips from China. All Tax and duty covered",
  tags: [],
  msrpDollars: 85,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:03.154Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
